import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AvailabilityItem\CreateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/CreateAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
const CreateAvailabilityItemController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAvailabilityItemController.url(options),
    method: 'post',
})

CreateAvailabilityItemController.definition = {
    methods: ["post"],
    url: '/api/unavailability/items',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AvailabilityItem\CreateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/CreateAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
CreateAvailabilityItemController.url = (options?: RouteQueryOptions) => {
    return CreateAvailabilityItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailabilityItem\CreateAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/CreateAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
CreateAvailabilityItemController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAvailabilityItemController.url(options),
    method: 'post',
})

export default CreateAvailabilityItemController